﻿
/* tslint:disable */
export namespace Constants
{
	/**
    * @description description: 'PartyType'
	* name: 'PartyType'
	* id: 100
    */
    export const enum PartyType {
        CodeTypeId = 100,
		/**
		* Description: 'Person Description'
		* Name: 'Person'
		* Id: 100
		*/
        Person = 100,
		/**
		* Description: 'OrganizationDescription'
		* Name: 'Organization'
		* Id: 101
		*/
        Organization = 101
    }

	/**
    * @description description: 'Business Type'
	* name: 'Business Type'
	* id: 101
    */
    export const enum BusinessType {
        CodeTypeId = 101,
		/**
		* Description: 'Corporation'
		* Name: 'Corporation'
		* Id: 102
		*/
        Corporation = 102,
		/**
		* Description: 'Limited Liability Partnership'
		* Name: 'Limited Liability Partnership'
		* Id: 103
		*/
        LimitedLiabilityPartnership = 103,
		/**
		* Description: 'Limited Liability Corporation'
		* Name: 'Limited Liability Corporation'
		* Id: 104
		*/
        LimitedLiabilityCorporation = 104,
		/**
		* Description: 'Sole Proprietorship'
		* Name: 'Sole Proprietorship'
		* Id: 105
		*/
        SoleProprietorship = 105
    }

	/**
    * @description description: 'Delivery End Time'
	* name: 'Delivery End Time'
	* id: 102
    */
    export const enum DeliveryEndTime {
        CodeTypeId = 102,
		/**
		* Description: 'Before 10:00pm'
		* Name: 'Before 10:00pm'
		* Id: 120
		*/
        BeforeTenPm = 120,
		/**
		* Description: '10:00pm'
		* Name: '10:00pm'
		* Id: 121
		*/
        TenPm = 121,
		/**
		* Description: '11:00pm'
		* Name: '11:00pm'
		* Id: 122
		*/
        ElevenPm = 122,
		/**
		* Description: 'Midnight'
		* Name: 'Midnight'
		* Id: 123
		*/
        Midnight = 123,
		/**
		* Description: '1:00am'
		* Name: '1:00am'
		* Id: 124
		*/
        OneAm = 124,
		/**
		* Description: '2:00am'
		* Name: '2:00am'
		* Id: 125
		*/
        TwoAm = 125,
		/**
		* Description: '3:00am or later'
		* Name: '3:00am or later'
		* Id: 126
		*/
        ThreeAmOrLater = 126,
		/**
		* Description: '24 hours'
		* Name: '24 hours'
		* Id: 127
		*/
        TwentyFourHours = 127
    }

	/**
    * @description description: 'Delivery Radius'
	* name: 'Delivery Radius'
	* id: 103
    */
    export const enum DeliveryRadius {
        CodeTypeId = 103,
		/**
		* Description: '2 miles or less'
		* Name: '2 miles or less'
		* Id: 128
		*/
        TwoMilesOrLess = 128,
		/**
		* Description: '3 miles'
		* Name: '3 miles'
		* Id: 129
		*/
        ThreeMiles = 129,
		/**
		* Description: '4 miles'
		* Name: '4 miles'
		* Id: 130
		*/
        FourMiles = 130,
		/**
		* Description: '5 miles'
		* Name: '5 miles'
		* Id: 131
		*/
        FiveMiles = 131,
		/**
		* Description: '6+ miles'
		* Name: '6+ miles'
		* Id: 132
		*/
        SixPlusMiles = 132
    }

	/**
    * @description description: 'Independent Contractor Use'
	* name: 'Independent Contractor Use'
	* id: 104
    */
    export const enum IndependentContractorUse {
        CodeTypeId = 104,
		/**
		* Description: 'No'
		* Name: 'No'
		* Id: 113
		*/
        No = 113,
		/**
		* Description: 'Yes with certs'
		* Name: 'Yes with certs'
		* Id: 114
		*/
        YesWithCerts = 114,
		/**
		* Description: 'Yes without certs'
		* Name: 'Yes without certs'
		* Id: 115
		*/
        YesWithoutCerts = 115
    }

	/**
    * @description description: 'Response Type'
	* name: 'Response Type'
	* id: 105
    */
    export const enum ResponseType {
        CodeTypeId = 105,
		/**
		* Description: 'List - Code Value'
		* Name: 'List - Code Value'
		* Id: 116
		*/
        ListCodeValue = 116,
		/**
		* Description: 'Boolean'
		* Name: 'Boolean'
		* Id: 117
		*/
        Boolean = 117,
		/**
		* Description: 'Short Text'
		* Name: 'Short Text'
		* Id: 118
		*/
        ShortText = 118,
		/**
		* Description: 'Integer'
		* Name: 'Integer'
		* Id: 119
		*/
        Integer = 119
    }

	/**
    * @description description: 'Vehicle Ownership'
	* name: 'Vehicle Ownership'
	* id: 106
    */
    export const enum VehicleOwnership {
        CodeTypeId = 106,
		/**
		* Description: 'Leased'
		* Name: 'Leased'
		* Id: 110
		*/
        Leased = 110,
		/**
		* Description: 'Owned'
		* Name: 'Owned'
		* Id: 111
		*/
        Owned = 111,
		/**
		* Description: 'Financed'
		* Name: 'Financed'
		* Id: 112
		*/
        Financed = 112
    }

	/**
    * @description description: 'Vehicle Usage'
	* name: 'Vehicle Usage'
	* id: 107
    */
    export const enum VehicleUsage {
        CodeTypeId = 107,
		/**
		* Description: 'Misc. Use'
		* Name: 'Misc. Use'
		* Id: 106
		*/
        MiscUse = 106,
		/**
		* Description: 'Delivery Vehicle (less than 25%)'
		* Name: 'Delivery Vehicle (less than 25%)'
		* Id: 107
		*/
        DeliveryVehicleLessThanTwentyFivePercent = 107,
		/**
		* Description: 'Delivery Vehicle (25% or more)'
		* Name: 'Delivery Vehicle (25% or more)'
		* Id: 108
		*/
        DeliveryVehicleTwentyFivePercentOrMore = 108,
		/**
		* Description: 'Catering Vehicle'
		* Name: 'Catering Vehicle'
		* Id: 109
		*/
        CateringVehicle = 109
    }

	/**
    * @description description: 'Policyholder User Relationship Type'
	* name: 'Policyholder User Relationship Type'
	* id: 108
    */
    export const enum PolicyholderUserRelationshipType {
        CodeTypeId = 108,
		/**
		* Description: 'Primary Contact'
		* Name: 'Primary Contact'
		* Id: 133
		*/
        PrimaryContact = 133,
		/**
		* Description: 'Billing Contact'
		* Name: 'Billing Contact'
		* Id: 134
		*/
        BillingContact = 134
    }

	/**
    * @description description: 'Submission Status'
	* name: 'Submission Status'
	* id: 109
    */
    export const enum SubmissionStatus {
        CodeTypeId = 109,
		/**
		* Description: 'Active'
		* Name: 'Active'
		* Id: 135
		*/
        Active = 135,
		/**
		* Description: 'Invitation'
		* Name: 'Invitation'
		* Id: 136
		*/
        Invitation = 136,
		/**
		* Description: 'Pending'
		* Name: 'Pending'
		* Id: 137
		*/
        Pending = 137,
		/**
		* Description: 'Quoted'
		* Name: 'Quoted'
		* Id: 138
		*/
        Quoted = 138,
		/**
		* Description: 'Referred'
		* Name: 'Referred'
		* Id: 139
		*/
        Referred = 139,
		/**
		* Description: 'Declined'
		* Name: 'Declined'
		* Id: 140
		*/
        Declined = 140,
		/**
		* Description: 'Bound'
		* Name: 'Bound'
		* Id: 141
		*/
        Bound = 141,
		/**
		* Description: 'Draft Invitation'
		* Name: 'DraftInvitation'
		* Id: 195
		*/
        Draftinvitation = 195,
		/**
		* Description: 'Error'
		* Name: 'InvitationError'
		* Id: 267
		*/
        Invitationerror = 267,
		/**
		* Description: 'Draft'
		* Name: 'Draft'
		* Id: 406
		*/
        Draft = 406
    }

	/**
    * @description description: 'Policy Status'
	* name: 'Policy Status'
	* id: 110
    */
    export const enum PolicyStatus {
        CodeTypeId = 110,
		/**
		* Description: 'In Force'
		* Name: 'In Force'
		* Id: 142
		*/
        InForce = 142,
		/**
		* Description: 'Pending Transaction'
		* Name: 'Pending Transaction'
		* Id: 143
		*/
        PendingTransaction = 143,
		/**
		* Description: 'Expired'
		* Name: 'Expired'
		* Id: 144
		*/
        Expired = 144,
		/**
		* Description: 'Cancelled'
		* Name: 'Cancelled'
		* Id: 145
		*/
        Cancelled = 145,
		/**
		* Description: 'Pending'
		* Name: 'Pending'
		* Id: 165
		*/
        Pending = 165
    }

	/**
    * @description description: 'Product Line'
	* name: 'Product Line'
	* id: 111
    */
    export const enum ProductLine {
        CodeTypeId = 111,
		/**
		* Description: 'Intrepid Restaurant Package'
		* Name: 'Intrepid Restaurant Package'
		* Id: 146
		*/
        IntrepidRestaurantPackage = 146,
		/**
		* Description: 'Intrepid Restaurant Workers Comp'
		* Name: 'Intrepid Restaurant Workers Comp'
		* Id: 147
		*/
        IntrepidRestaurantWorkersComp = 147,
		/**
		* Description: 'Intrepid Delivery Auto'
		* Name: 'Intrepid Delivery Auto'
		* Id: 148
		*/
        IntrepidDeliveryAuto = 148
    }

	/**
    * @description description: 'Payment Type'
	* name: 'Payment Type'
	* id: 112
    */
    export const enum PaymentType {
        CodeTypeId = 112,
		/**
		* Description: 'Credit Card'
		* Name: 'Credit Card'
		* Id: 149
		*/
        CreditCard = 149,
		/**
		* Description: 'ACH'
		* Name: 'ACH'
		* Id: 150
		*/
        Ach = 150,
		/**
		* Description: 'Check'
		* Name: 'Check'
		* Id: 151
		*/
        Check = 151
    }

	/**
    * @description description: 'Phone Type'
	* name: 'Phone Type'
	* id: 113
    */
    export const enum PhoneType {
        CodeTypeId = 113,
		/**
		* Description: 'Work'
		* Name: 'Work'
		* Id: 152
		*/
        Work = 152,
		/**
		* Description: 'Mobile'
		* Name: 'Mobile'
		* Id: 153
		*/
        Mobile = 153,
		/**
		* Description: 'Home'
		* Name: 'Home'
		* Id: 154
		*/
        Home = 154
    }

	/**
    * @description description: 'Line Of Business'
	* name: 'Line Of Business'
	* id: 114
    */
    export const enum LineOfBusiness {
        CodeTypeId = 114,
		/**
		* Description: 'Commercial Auto that is part of the Delivery Auto Policy'
		* Name: 'Commercial Auto'
		* Id: 155
		*/
        CommercialAuto = 155,
		/**
		* Description: 'Commercial Property'
		* Name: 'Commercial Property'
		* Id: 156
		*/
        CommercialProperty = 156,
		/**
		* Description: 'General Liability'
		* Name: 'General Liability'
		* Id: 157
		*/
        GeneralLiability = 157,
		/**
		* Description: 'Commercial Umbrella'
		* Name: 'Commercial Umbrella'
		* Id: 158
		*/
        CommercialUmbrella = 158,
		/**
		* Description: 'Workers Comp'
		* Name: 'Workers Comp'
		* Id: 159
		*/
        WorkersComp = 159,
		/**
		* Description: 'Commercial Auto that is part of the Package Policy'
		* Name: 'Commercial Auto - Package'
		* Id: 262
		*/
        CommercialAutoPackage = 262
    }

	/**
    * @description description: 'Invitation Status'
	* name: 'Invitation Status'
	* id: 115
    */
    export const enum InvitationStatus {
        CodeTypeId = 115,
		/**
		* Description: 'Active'
		* Name: 'Active'
		* Id: 160
		*/
        Active = 160
    }

	/**
    * @description description: 'Coverage'
	* name: 'Coverage'
	* id: 116
    */
    export const enum Coverage {
        CodeTypeId = 116,
		/**
		* Description: 'Building'
		* Name: 'Building'
		* Id: 161
		*/
        Building = 161,
		/**
		* Description: 'Personal Property'
		* Name: 'Personal Property'
		* Id: 162
		*/
        PersonalProperty = 162,
		/**
		* Description: 'Time Element'
		* Name: 'Time Element'
		* Id: 163
		*/
        TimeElement = 163,
		/**
		* Description: 'Tenant Improvement'
		* Name: 'Tenant Improvement'
		* Id: 164
		*/
        TenantImprovement = 164,
		/**
		* Description: 'Alaska Attorney's Fees'
		* Name: 'Alaska Attorney's Fees'
		* Id: 234
		*/
        AlaskaAttorneysFees = 234,
		/**
		* Description: 'Deficit Reduction Surcharge'
		* Name: 'Deficit Reduction Surcharge'
		* Id: 235
		*/
        DeficitReductionSurcharge = 235,
		/**
		* Description: 'Emergency Mgmnt Preparedness & Assistance Trst'
		* Name: 'Emergency Mgmnt Preparedness & Assistance Trst'
		* Id: 236
		*/
        EmergencyMgmntPreparednessAssistanceTrst = 236,
		/**
		* Description: 'Filing Fee'
		* Name: 'Filing Fee'
		* Id: 237
		*/
        FilingFee = 237,
		/**
		* Description: 'Fire and Casualty Surcharge'
		* Name: 'Fire and Casualty Surcharge'
		* Id: 238
		*/
        FireAndCasualtySurcharge = 238,
		/**
		* Description: 'Fire Safety Surcharge'
		* Name: 'Fire Safety Surcharge'
		* Id: 239
		*/
        FireSafetySurcharge = 239,
		/**
		* Description: 'WCFA (Fraud Assessment) - CA'
		* Name: 'WCFA (Fraud Assessment) - CA'
		* Id: 240
		*/
        WcfaFraudAssessmentCa = 240,
		/**
		* Description: 'CIGA (CA Ins Guarantee Assoc) - CA'
		* Name: 'CIGA (CA Ins Guarantee Assoc) - CA'
		* Id: 241
		*/
        CigaCaInsGuaranteeAssocCa = 241,
		/**
		* Description: 'Industrial Comm Surcharge'
		* Name: 'Industrial Comm Surcharge'
		* Id: 242
		*/
        IndustrialCommSurcharge = 242,
		/**
		* Description: 'LEC (Labor Enforcement & Compliance Fund) - CA'
		* Name: 'LEC (Labor Enforcement & Compliance Fund) - CA'
		* Id: 243
		*/
        LecLaborEnforcementComplianceFundCa = 243,
		/**
		* Description: 'NJ Surcharge'
		* Name: 'NJ Surcharge'
		* Id: 244
		*/
        NjSurcharge = 244,
		/**
		* Description: 'New York Fire Fee'
		* Name: 'New York Fire Fee'
		* Id: 245
		*/
        NewYorkFireFee = 245,
		/**
		* Description: 'OSHF (Occupational Safety & Health Fund) - CA'
		* Name: 'OSHF (Occupational Safety & Health Fund) - CA'
		* Id: 246
		*/
        OshfOccupationalSafetyHealthFundCa = 246,
		/**
		* Description: 'Regulatory Surcharge'
		* Name: 'Regulatory Surcharge'
		* Id: 247
		*/
        RegulatorySurcharge = 247,
		/**
		* Description: 'SIBT (Subsequent Inj Benefits Trust Fund) - CA'
		* Name: 'SIBT (Subsequent Inj Benefits Trust Fund) - CA'
		* Id: 248
		*/
        SibtSubsequentInjBenefitsTrustFundCa = 248,
		/**
		* Description: 'Second Inj Fund Assess'
		* Name: 'Second Inj Fund Assess'
		* Id: 249
		*/
        SecondInjFundAssess = 249,
		/**
		* Description: 'Security Fund Surcharge'
		* Name: 'Security Fund Surcharge'
		* Id: 250
		*/
        SecurityFundSurcharge = 250,
		/**
		* Description: 'Occupational Safety and Health Regulatory Assessment Surcharge'
		* Name: 'Occupational Safety and Health Regulatory Assessment Surcharge'
		* Id: 251
		*/
        OccupationalSafetyAndHealthRegulatoryAssessmentSurcharge = 251,
		/**
		* Description: 'Supplemental SIF Assessment'
		* Name: 'Supplemental SIF Assessment'
		* Id: 252
		*/
        SupplementalSifAssessment = 252,
		/**
		* Description: 'Special Comp Fund Surcharge'
		* Name: 'Special Comp Fund Surcharge'
		* Id: 253
		*/
        SpecialCompFundSurcharge = 253,
		/**
		* Description: 'KY Surcharge'
		* Name: 'KY Surcharge'
		* Id: 254
		*/
        KySurcharge = 254,
		/**
		* Description: 'WCA (WC Revolving Fund) - CA'
		* Name: 'WCA (WC Revolving Fund) - CA'
		* Id: 255
		*/
        WcaWcRevolvingFundCa = 255,
		/**
		* Description: 'Supple Benefits Srchg'
		* Name: 'Supple Benefits Srchg'
		* Id: 256
		*/
        SuppleBenefitsSrchg = 256,
		/**
		* Description: 'KY Municipal Tax'
		* Name: 'KY Municipal Tax'
		* Id: 257
		*/
        KyMunicipalTax = 257,
		/**
		* Description: 'UEBT (Uninsured Employers Benefits Trust Fund) - CA'
		* Name: 'UEBT (Uninsured Employers Benefits Trust Fund) - CA'
		* Id: 258
		*/
        UebtUninsuredEmployersBenefitsTrustFundCa = 258,
		/**
		* Description: 'Uninsured Employers Fund Surcharge'
		* Name: 'Uninsured Employers Fund Surcharge'
		* Id: 259
		*/
        UninsuredEmployersFundSurcharge = 259,
		/**
		* Description: 'WC Assessment/Surcharge'
		* Name: 'WC Assessment/Surcharge'
		* Id: 260
		*/
        WcAssessmentsurcharge = 260,
		/**
		* Description: 'Stay At Work Return To Work Premium Surcharge'
		* Name: 'Stay At Work Return To Work Premium Surcharge'
		* Id: 261
		*/
        StayAtWorkReturnToWorkPremiumSurcharge = 261,
		/**
		* Description: 'Premium Discount - Federal'
		* Name: 'Premium Discount - Federal'
		* Id: 405
		*/
        PremiumDiscountFederal = 405,
		/**
		* Description: 'State Fire Marshall Surcharge'
		* Name: 'State Fire Marshall Surcharge'
		* Id: 420
		*/
        StateFireMarshallSurcharge = 420
    }

	/**
    * @description description: 'Hazard Grade'
	* name: 'Hazard Grade'
	* id: 117
    */
    export const enum HazardGrade {
        CodeTypeId = 117,
		/**
		* Description: 'Low'
		* Name: 'Low'
		* Id: 166
		*/
        Low = 166,
		/**
		* Description: 'Medium'
		* Name: 'Medium'
		* Id: 167
		*/
        Medium = 167,
		/**
		* Description: 'High'
		* Name: 'High'
		* Id: 168
		*/
        High = 168
    }

	/**
    * @description description: 'Cyber Aggregate Limit Amount Code'
	* name: 'Cyber Aggregate Limit Amount Code'
	* id: 119
    */
    export const enum CyberAggregateLimitAmountCode {
        CodeTypeId = 119,
		/**
		* Description: '25,000'
		* Name: '25,000'
		* Id: 171
		*/
        TwentyFiveThousand = 171,
		/**
		* Description: '50,000'
		* Name: '50,000'
		* Id: 172
		*/
        FiftyThousand = 172,
		/**
		* Description: '100,000'
		* Name: '100,000'
		* Id: 173
		*/
        OneHundredThousand = 173
    }

	/**
    * @description description: 'Umbrella Limit Amount Code'
	* name: 'Umbrella Limit Amount Code'
	* id: 120
    */
    export const enum UmbrellaLimitAmountCode {
        CodeTypeId = 120,
		/**
		* Description: '$1,000,000'
		* Name: '$1,000,000'
		* Id: 174
		*/
        OneMillion = 174,
		/**
		* Description: '$2,000,000'
		* Name: '$2,000,000'
		* Id: 175
		*/
        TwoMillion = 175,
		/**
		* Description: '$3,000,000'
		* Name: '$3,000,000'
		* Id: 176
		*/
        ThreeMillion = 176,
		/**
		* Description: '$4,000,000'
		* Name: '$4,000,000'
		* Id: 177
		*/
        FourMillion = 177,
		/**
		* Description: '$5,000,000'
		* Name: '$5,000,000'
		* Id: 178
		*/
        FiveMillion = 178,
		/**
		* Description: '$6,000,000'
		* Name: '$6,000,000'
		* Id: 263
		*/
        SixMillion = 263,
		/**
		* Description: '$7,000,000'
		* Name: '$7,000,000'
		* Id: 264
		*/
        SevenMillion = 264,
		/**
		* Description: '$8,000,000'
		* Name: '$8,000,000'
		* Id: 265
		*/
        EightMillion = 265,
		/**
		* Description: '$9,000,000'
		* Name: '$9,000,000'
		* Id: 266
		*/
        NineMillion = 266,
		/**
		* Description: '$10,000,000'
		* Name: '$10,000,000'
		* Id: 464
		*/
        TenMillion = 464
    }

	/**
    * @description description: 'General Liability Deductible Amount Code'
	* name: 'General Liability Deductible Amount Code'
	* id: 121
    */
    export const enum GeneralLiabilityDeductibleAmountCode {
        CodeTypeId = 121,
		/**
		* Description: '1,000'
		* Name: '1,000'
		* Id: 179
		*/
        OneThousand = 179
    }

	/**
    * @description description: 'Commercial Property Deductible Amount Code'
	* name: 'Commercial Property Deductible Amount Code'
	* id: 122
    */
    export const enum CommercialPropertyDeductibleAmountCode {
        CodeTypeId = 122,
		/**
		* Description: '$1,000'
		* Name: '$1,000'
		* Id: 180
		*/
        OneThousand = 180,
		/**
		* Description: '$250'
		* Name: '$250'
		* Id: 268
		*/
        TwoHundredAndFifty = 268,
		/**
		* Description: '$500'
		* Name: '$500'
		* Id: 269
		*/
        FiveHundred = 269,
		/**
		* Description: '$2,500'
		* Name: '$2,500'
		* Id: 270
		*/
        TwoThousandFiveHundred = 270,
		/**
		* Description: '$5,000'
		* Name: '$5,000'
		* Id: 271
		*/
        FiveThousand = 271,
		/**
		* Description: '$10,000'
		* Name: '$10,000'
		* Id: 272
		*/
        TenThousand = 272,
		/**
		* Description: '$25,000'
		* Name: '$25,000'
		* Id: 273
		*/
        TwentyFiveThousand = 273,
		/**
		* Description: '$50,000'
		* Name: '$50,000'
		* Id: 274
		*/
        FiftyThousand = 274,
		/**
		* Description: '$75,000'
		* Name: '$75,000'
		* Id: 275
		*/
        SeventyFiveThousand = 275
    }

	/**
    * @description description: 'Rules Decision'
	* name: 'Rules Decision'
	* id: 123
    */
    export const enum RulesDecision {
        CodeTypeId = 123,
		/**
		* Description: 'Rating Tier - Liability'
		* Name: 'Rating Tier - Liability'
		* Id: 181
		*/
        RatingTierLiability = 181,
		/**
		* Description: 'Rating Tier - Property'
		* Name: 'Rating Tier - Property'
		* Id: 182
		*/
        RatingTierProperty = 182
    }

	/**
    * @description description: 'Rating Tier - Liability'
	* name: 'Rating Tier - Liability'
	* id: 124
    */
    export const enum RatingTierLiability {
        CodeTypeId = 124,
		/**
		* Description: 'Tier 0'
		* Name: 'Tier 0'
		* Id: 183
		*/
        TierZero = 183,
		/**
		* Description: 'Tier 1'
		* Name: 'Tier 1'
		* Id: 184
		*/
        TierOne = 184,
		/**
		* Description: 'Tier 2'
		* Name: 'Tier 2'
		* Id: 185
		*/
        TierTwo = 185,
		/**
		* Description: 'Tier 3'
		* Name: 'Tier 3'
		* Id: 186
		*/
        TierThree = 186,
		/**
		* Description: 'Tier 4'
		* Name: 'Tier 4'
		* Id: 187
		*/
        TierFour = 187
    }

	/**
    * @description description: 'Rating Tier - Property'
	* name: 'Rating Tier - Property'
	* id: 125
    */
    export const enum RatingTierProperty {
        CodeTypeId = 125,
		/**
		* Description: 'Tier 0'
		* Name: 'Tier 0'
		* Id: 188
		*/
        TierZero = 188,
		/**
		* Description: 'Tier 1'
		* Name: 'Tier 1'
		* Id: 189
		*/
        TierOne = 189,
		/**
		* Description: 'Tier 2'
		* Name: 'Tier 2'
		* Id: 190
		*/
        TierTwo = 190,
		/**
		* Description: 'Tier 3'
		* Name: 'Tier 3'
		* Id: 191
		*/
        TierThree = 191,
		/**
		* Description: 'Tier 4'
		* Name: 'Tier 4'
		* Id: 192
		*/
        TierFour = 192
    }

	/**
    * @description description: 'Liability Limit Amount Code for HNO as applied to the Commercial Auto Line of Business on an HNO Policy'
	* name: 'HNO Liability Limit Amount Code'
	* id: 126
    */
    export const enum HNOLiabilityLimitAmountCode {
        CodeTypeId = 126,
		/**
		* Description: '$2,000,000'
		* Name: '$2,000,000'
		* Id: 193
		*/
        TwoMillion = 193,
		/**
		* Description: '$1,000,000'
		* Name: '$1,000,000'
		* Id: 194
		*/
        OneMillion = 194,
		/**
		* Description: '$100,000'
		* Name: '$100,000'
		* Id: 282
		*/
        OneHundredThousand = 282,
		/**
		* Description: '$500,000'
		* Name: '$500,000'
		* Id: 283
		*/
        FiveHundredThousand = 283,
		/**
		* Description: '$1,500,000'
		* Name: '$1,500,000'
		* Id: 284
		*/
        OneMillionFiveHundredThousand = 284
    }

	/**
    * @description description: 'ExcessSurplusFeeSurchargeTaxType'
	* name: 'ExcessSurplusFeeSurchargeTaxType'
	* id: 127
    */
    export const enum ExcessSurplusFeeSurchargeTaxType {
        CodeTypeId = 127,
		/**
		* Description: 'Surplus Lines Tax'
		* Name: 'Surplus Lines Tax'
		* Id: 196
		*/
        SurplusLinesTax = 196,
		/**
		* Description: 'Stamping Fees'
		* Name: 'Stamping Fees'
		* Id: 197
		*/
        StampingFees = 197,
		/**
		* Description: 'Fire Marshall Fees'
		* Name: 'Fire Marshall Fees'
		* Id: 198
		*/
        FireMarshallFees = 198,
		/**
		* Description: 'Surplus Surcharge'
		* Name: 'Surplus Surcharge'
		* Id: 199
		*/
        SurplusSurcharge = 199,
		/**
		* Description: 'FL DFS Premium Receipts Tax'
		* Name: 'FL DFS Premium Receipts Tax'
		* Id: 200
		*/
        FlDfsPremiumReceiptsTax = 200,
		/**
		* Description: 'FSLSO Fee'
		* Name: 'FSLSO Fee'
		* Id: 201
		*/
        FslsoFee = 201,
		/**
		* Description: 'Surplus Lines Surcharge'
		* Name: 'Surplus Lines Surcharge'
		* Id: 202
		*/
        SurplusLinesSurcharge = 202,
		/**
		* Description: 'Clearinghouse Transaction Fee'
		* Name: 'Clearinghouse Transaction Fee'
		* Id: 207
		*/
        ClearinghouseTransactionFee = 207,
		/**
		* Description: 'State Tax Misc Fee'
		* Name: 'State Tax Misc Fee'
		* Id: 208
		*/
        StateTaxMiscFee = 208,
		/**
		* Description: 'Filing Fee'
		* Name: 'Filing Fee'
		* Id: 209
		*/
        FilingFee = 209,
		/**
		* Description: 'Regulatory Fees'
		* Name: 'Regulatory Fees'
		* Id: 210
		*/
        RegulatoryFees = 210,
		/**
		* Description: 'MS Windstorm Underwriting Association policy fee'
		* Name: 'MS Windstorm Underwriting Association policy fee'
		* Id: 390
		*/
        MsWindstormUnderwritingAssociationPolicyFee = 390
    }

	/**
    * @description description: 'SubmissionStatusReasons'
	* name: 'SubmissionStatusReasons'
	* id: 128
    */
    export const enum SubmissionStatusReasons {
        CodeTypeId = 128,
		/**
		* Description: 'Large Loss - General Liability'
		* Name: 'Large Loss - General Liability'
		* Id: 203
		*/
        LargeLossGeneralLiability = 203,
		/**
		* Description: 'Large Loss - Hired and Non-owned Auto'
		* Name: 'Large Loss - Hired and Non-owned Auto'
		* Id: 204
		*/
        LargeLossHiredAndNonownedAuto = 204,
		/**
		* Description: 'Large Loss - Workers Comp'
		* Name: 'Large Loss - Workers Comp'
		* Id: 205
		*/
        LargeLossWorkersComp = 205,
		/**
		* Description: 'Large Loss - Property'
		* Name: 'Large Loss - Property'
		* Id: 206
		*/
        LargeLossProperty = 206,
		/**
		* Description: 'Jimmy John's with 11 or more locations'
		* Name: 'Jimmy John's with 11 or more locations'
		* Id: 233
		*/
        JimmyJohnsWithElevenOrMoreLocations = 233,
		/**
		* Description: 'Delivery Vehicle Inspection'
		* Name: 'Delivery Vehicle Inspection'
		* Id: 299
		*/
        DeliveryVehicleInspection = 299,
		/**
		* Description: 'Bicycle Delivery'
		* Name: 'Bicycle Delivery'
		* Id: 300
		*/
        BicycleDelivery = 300,
		/**
		* Description: 'Claim Frequency - Auto Liability'
		* Name: 'Claim Frequency - Auto Liability'
		* Id: 301
		*/
        ClaimFrequencyAutoLiability = 301,
		/**
		* Description: 'Inadequate Driver Safety Program'
		* Name: 'Inadequate Driver Safety Program'
		* Id: 302
		*/
        InadequateDriverSafetyProgram = 302,
		/**
		* Description: 'Coastal State'
		* Name: 'Coastal State'
		* Id: 303
		*/
        CoastalState = 303,
		/**
		* Description: 'Owned Buildings'
		* Name: 'Owned Buildings'
		* Id: 304
		*/
        OwnedBuildings = 304,
		/**
		* Description: 'Liquor Sales Exceed 3%'
		* Name: 'Liquor Sales Exceed 3%'
		* Id: 305
		*/
        LiquorSalesExceedThreePercent = 305,
		/**
		* Description: 'Too Many Locations'
		* Name: 'Too Many Locations'
		* Id: 306
		*/
        TooManyLocations = 306,
		/**
		* Description: 'Not Currently Insured'
		* Name: 'Not Currently Insured'
		* Id: 307
		*/
        NotCurrentlyInsured = 307,
		/**
		* Description: 'Ownership Interests in Other Businesses.'
		* Name: 'Ownership Interests in Other Businesses.'
		* Id: 308
		*/
        OwnershipInterestsInOtherBusinesses = 308,
		/**
		* Description: 'Non-renewed or Cancelled'
		* Name: 'Non-renewed or Cancelled'
		* Id: 309
		*/
        NonrenewedOrCancelled = 309,
		/**
		* Description: 'Claim Frequency - General Liability'
		* Name: 'Claim Frequency - General Liability'
		* Id: 310
		*/
        ClaimFrequencyGeneralLiability = 310,
		/**
		* Description: 'Claim Frequency - Workers Comp'
		* Name: 'Claim Frequency - Workers Comp'
		* Id: 311
		*/
        ClaimFrequencyWorkersComp = 311,
		/**
		* Description: 'Workers Comp Exp Mod too High'
		* Name: 'Workers Comp Exp Mod too High'
		* Id: 312
		*/
        WorkersCompExpModTooHigh = 312,
		/**
		* Description: 'Non Delivery Restaurant with Excessive Delivery Sales'
		* Name: 'Non Delivery Restaurant with Excessive Delivery Sales'
		* Id: 313
		*/
        NonDeliveryRestaurantWithExcessiveDeliverySales = 313,
		/**
		* Description: 'Non Delivery Restaurant with Delivery Payroll'
		* Name: 'Non Delivery Restaurant with Delivery Payroll'
		* Id: 314
		*/
        NonDeliveryRestaurantWithDeliveryPayroll = 314,
		/**
		* Description: 'Non-Established Brand'
		* Name: 'Non-Established Brand'
		* Id: 315
		*/
        NonestablishedBrand = 315,
		/**
		* Description: 'No brand was associated with the submission.'
		* Name: 'Brand Unspecified'
		* Id: 316
		*/
        BrandUnspecified = 316,
		/**
		* Description: 'There is no effective date for the submission.'
		* Name: 'Policy Effective Date Unspecified'
		* Id: 317
		*/
        PolicyEffectiveDateUnspecified = 317,
		/**
		* Description: 'Unverified Address'
		* Name: 'Unverified Address'
		* Id: 318
		*/
        UnverifiedAddress = 318,
		/**
		* Description: 'Address Missing County'
		* Name: 'Address Missing County'
		* Id: 319
		*/
        AddressMissingCounty = 319,
		/**
		* Description: 'Address Missing City'
		* Name: 'Address Missing City'
		* Id: 320
		*/
        AddressMissingCity = 320,
		/**
		* Description: 'Address Missing State'
		* Name: 'Address Missing State'
		* Id: 321
		*/
        AddressMissingState = 321,
		/**
		* Description: 'Address Missing Zip Code'
		* Name: 'Address Missing Zip Code'
		* Id: 322
		*/
        AddressMissingZipCode = 322,
		/**
		* Description: 'Address Missing Street Address Line One'
		* Name: 'Address Missing Street Address Line One'
		* Id: 323
		*/
        AddressMissingStreetAddressLineOne = 323,
		/**
		* Description: 'Location Missing Territory Code Property'
		* Name: 'Location Missing Territory Code Property'
		* Id: 324
		*/
        LocationMissingTerritoryCodeProperty = 324,
		/**
		* Description: 'Location Missing Territory Code Liability'
		* Name: 'Location Missing Territory Code Liability'
		* Id: 325
		*/
        LocationMissingTerritoryCodeLiability = 325,
		/**
		* Description: 'Location Missing Territory Code Auto'
		* Name: 'Location Missing Territory Code Auto'
		* Id: 326
		*/
        LocationMissingTerritoryCodeAuto = 326,
		/**
		* Description: 'Location Missing Territory Code Terrorism'
		* Name: 'Location Missing Territory Code Terrorism'
		* Id: 327
		*/
        LocationMissingTerritoryCodeTerrorism = 327,
		/**
		* Description: 'Location Missing Protection Class'
		* Name: 'Location Missing Protection Class'
		* Id: 328
		*/
        LocationMissingProtectionClass = 328,
		/**
		* Description: 'Location Missing Property Rating Type'
		* Name: 'Location Missing Property Rating Type'
		* Id: 329
		*/
        LocationMissingPropertyRatingType = 329,
		/**
		* Description: 'Location Missing Construction Type'
		* Name: 'Location Missing Construction Type'
		* Id: 330
		*/
        LocationMissingConstructionType = 330,
		/**
		* Description: 'Location Missing Group II Symbol'
		* Name: 'Location Missing Group II Symbol'
		* Id: 331
		*/
        LocationMissingGroupIiSymbol = 331,
		/**
		* Description: 'Location Missing Group II Zone'
		* Name: 'Location Missing Group II Zone'
		* Id: 332
		*/
        LocationMissingGroupIiZone = 332,
		/**
		* Description: 'Location Missing BCEG'
		* Name: 'Location Missing BCEG'
		* Id: 333
		*/
        LocationMissingBceg = 333,
		/**
		* Description: 'Location Missing Class Code Liability No Liquor'
		* Name: 'Location Missing Class Code Liability No Liquor'
		* Id: 334
		*/
        LocationMissingClassCodeLiabilityNoLiquor = 334,
		/**
		* Description: 'Location Missing Class Code Liability Liquor'
		* Name: 'Location Missing Class Code Liability Liquor'
		* Id: 335
		*/
        LocationMissingClassCodeLiabilityLiquor = 335,
		/**
		* Description: 'Genesys Submission Error'
		* Name: 'Genesys Submission Error'
		* Id: 337
		*/
        GenesysSubmissionError = 337,
		/**
		* Description: 'Quote Wizard Unhandled Exception'
		* Name: 'Quote Wizard Unhandled Exception'
		* Id: 342
		*/
        QuoteWizardUnhandledException = 342,
		/**
		* Description: 'Owned or leased vehicles associated with the business.'
		* Name: 'Owned or Leased Vehicles'
		* Id: 352
		*/
        OwnedOrLeasedVehicles = 352,
		/**
		* Description: 'Building value less than 100k. Check for adequate TIV.'
		* Name: 'Building Value Less than 100k'
		* Id: 353
		*/
        BuildingValueLessThan100k = 353,
		/**
		* Description: 'Building value greater than 500k.'
		* Name: 'Building Value Greater than 500k'
		* Id: 354
		*/
        BuildingValueGreaterThan500k = 354,
		/**
		* Description: 'Not sure about claims in last 3 years.'
		* Name: 'Unsure About Claims Last 3 years'
		* Id: 355
		*/
        UnsureAboutClaimsLastThreeYears = 355,
		/**
		* Description: 'Robbery or assault claims'
		* Name: 'Robbery or Assault Claims'
		* Id: 356
		*/
        RobberyOrAssaultClaims = 356,
		/**
		* Description: 'No management system used to monitor drivers' insurance or licenses'
		* Name: 'Driver Expiration Dates Monitored'
		* Id: 357
		*/
        DriverExpirationDatesMonitored = 357,
		/**
		* Description: 'One or more locations in an unsupported state'
		* Name: 'Unsupported State'
		* Id: 358
		*/
        UnsupportedState = 358,
		/**
		* Description: 'The submission request has a policy effective date in the past.'
		* Name: 'Policy Effective Date Past'
		* Id: 359
		*/
        PolicyEffectiveDatePast = 359,
		/**
		* Description: 'The submission request has a policy effective date too far in the future.'
		* Name: 'Policy Effective Date Future'
		* Id: 360
		*/
        PolicyEffectiveDateFuture = 360,
		/**
		* Description: 'The submission request is for a brand that does not have a matching configuration in the marketplace.'
		* Name: 'Brand Configuration Missing'
		* Id: 361
		*/
        BrandConfigurationMissing = 361,
		/**
		* Description: 'The submission request contains an unexpected brand id such as a negative number.'
		* Name: 'Brand Unexpected'
		* Id: 362
		*/
        BrandUnexpected = 362,
		/**
		* Description: 'The submission request does not have a primary contact.'
		* Name: 'Primary Contact Missing'
		* Id: 363
		*/
        PrimaryContactMissing = 363,
		/**
		* Description: 'The submission request contains a reference to an existing policyholder that is unexpected.'
		* Name: 'Policyholder Unexpected'
		* Id: 364
		*/
        PolicyholderUnexpected = 364,
		/**
		* Description: 'The submission request must specify the HNOA claims question response.'
		* Name: 'HNOA claims question response missing'
		* Id: 365
		*/
        HnoaClaimsQuestionResponseMissing = 365,
		/**
		* Description: 'The submission request must specify the HNOA claims over limit question response.'
		* Name: 'HNOA claims over limit question response missing'
		* Id: 366
		*/
        HnoaClaimsOverLimitQuestionResponseMissing = 366,
		/**
		* Description: 'The submission request must only specify a true value for the HNOA claims over limit question response if the HNOA claims question response was also true.'
		* Name: 'HNOA claims over limit question response invalid'
		* Id: 367
		*/
        HnoaClaimsOverLimitQuestionResponseInvalid = 367,
		/**
		* Description: 'The submission request must specify the Liability claims question response.'
		* Name: 'Liability claims question response missing'
		* Id: 368
		*/
        LiabilityClaimsQuestionResponseMissing = 368,
		/**
		* Description: 'The submission request must specify the Liability claims over limit question response.'
		* Name: 'Liability claims over limit question response missing'
		* Id: 369
		*/
        LiabilityClaimsOverLimitQuestionResponseMissing = 369,
		/**
		* Description: 'The submission request must only specify a true value for the Liability claims over limit question response if the Liability claims question response was also true.'
		* Name: 'Liability claims over limit question response invalid'
		* Id: 370
		*/
        LiabilityClaimsOverLimitQuestionResponseInvalid = 370,
		/**
		* Description: 'The submission request must specify the Other claims question response.'
		* Name: 'Other claims question response missing'
		* Id: 371
		*/
        OtherClaimsQuestionResponseMissing = 371,
		/**
		* Description: 'The submission request must specify the Other claims over limit question response.'
		* Name: 'Other claims over limit question response missing'
		* Id: 372
		*/
        OtherClaimsOverLimitQuestionResponseMissing = 372,
		/**
		* Description: 'The submission request must only specify a true value for the Other claims over limit question response if the Other claims question response was also true.'
		* Name: 'Other claims over limit question response invalid'
		* Id: 373
		*/
        OtherClaimsOverLimitQuestionResponseInvalid = 373,
		/**
		* Description: 'The submission request must specify the Owned Auto claims question response.'
		* Name: 'Owned Auto claims question response missing'
		* Id: 374
		*/
        OwnedAutoClaimsQuestionResponseMissing = 374,
		/**
		* Description: 'The submission request must specify the Owned Auto claims over limit question response.'
		* Name: 'Owned Auto claims over limit question response missing'
		* Id: 375
		*/
        OwnedAutoClaimsOverLimitQuestionResponseMissing = 375,
		/**
		* Description: 'The submission request must only specify a true value for the Owned Auto claims over limit question response if the Owned Auto claims question response was also true.'
		* Name: 'Owned Auto claims over limit question response invalid'
		* Id: 376
		*/
        OwnedAutoClaimsOverLimitQuestionResponseInvalid = 376,
		/**
		* Description: 'The submission request must specify the Property claims question response.'
		* Name: 'Property claims question response missing'
		* Id: 377
		*/
        PropertyClaimsQuestionResponseMissing = 377,
		/**
		* Description: 'The submission request must specify the Property claims over limit question response.'
		* Name: 'Property claims over limit question response missing'
		* Id: 378
		*/
        PropertyClaimsOverLimitQuestionResponseMissing = 378,
		/**
		* Description: 'The submission request must only specify a true value for the Property claims over limit question response if the Property claims question response was also true.'
		* Name: 'Property claims over limit question response invalid'
		* Id: 379
		*/
        PropertyClaimsOverLimitQuestionResponseInvalid = 379,
		/**
		* Description: 'The submission request must specify the Work Comp claims question response.'
		* Name: 'Work Comp claims question response missing'
		* Id: 380
		*/
        WorkCompClaimsQuestionResponseMissing = 380,
		/**
		* Description: 'The submission request must specify the Work Comp claims over limit question response.'
		* Name: 'Work Comp claims over limit question response missing'
		* Id: 381
		*/
        WorkCompClaimsOverLimitQuestionResponseMissing = 381,
		/**
		* Description: 'The submission request must only specify a true value for the Work Comp claims over limit question response if the Work Comp claims question response was also true.'
		* Name: 'Work Comp claims over limit question response invalid'
		* Id: 382
		*/
        WorkCompClaimsOverLimitQuestionResponseInvalid = 382,
		/**
		* Description: 'The submission request has some claim types question responses not "false" when the "has claims" question response is No.'
		* Name: 'All claim types not false when has claims is no'
		* Id: 383
		*/
        AllClaimTypesNotFalseWhenHasClaimsIsNo = 383,
		/**
		* Description: 'The submission request has some claim types question responses not "NULL" when the "has claims" question response is Not Sure.'
		* Name: 'All claim types not NULL when has claims is not sure'
		* Id: 384
		*/
        AllClaimTypesNotNullWhenHasClaimsIsNotSure = 384,
		/**
		* Description: 'The submission request must specify the has claims question response.'
		* Name: 'Has claims question response missing'
		* Id: 385
		*/
        HasClaimsQuestionResponseMissing = 385,
		/**
		* Description: 'Not enough years in business'
		* Name: 'Not enough years in business'
		* Id: 386
		*/
        NotEnoughYearsInBusiness = 386,
		/**
		* Description: 'ISO Address Lookup Error'
		* Name: 'ISO Address Lookup Error'
		* Id: 387
		*/
        IsoAddressLookupError = 387,
		/**
		* Description: 'Large Loss - Owned Auto'
		* Name: 'Large Loss - Owned Auto'
		* Id: 388
		*/
        LargeLossOwnedAuto = 388,
		/**
		* Description: 'Large Loss - Other'
		* Name: 'Large Loss - Other'
		* Id: 389
		*/
        LargeLossOther = 389,
		/**
		* Description: 'A building exists in area that is high risk for wind or hail damage.'
		* Name: 'Owned buildings in W1 or H1'
		* Id: 392
		*/
        OwnedBuildingsInW1OrH1 = 392,
		/**
		* Description: 'Business personal property declared in area that is high risk for wind or hail damage.'
		* Name: 'BPP in W1 or H1'
		* Id: 393
		*/
        BppInW1OrH1 = 393,
		/**
		* Description: 'Delivery Auto Policy With Kentucky Primary State'
		* Name: 'Delivery Auto Policy With Kentucky Primary State'
		* Id: 424
		*/
        DeliveryAutoPolicyWithKentuckyPrimaryState = 424,
		/**
		* Description: 'DA policy for DE locations needed in addition to existing'
		* Name: 'DA policy for DE locations needed in addition to existing'
		* Id: 465
		*/
        DaPolicyForDeLocationsNeededInAdditionToExisting = 465,
		/**
		* Description: 'Liquor sales exceed 10%'
		* Name: 'Liquor sales exceed 10%'
		* Id: 466
		*/
        LiquorSalesExceedTenPercent = 466,
		/**
		* Description: 'Workers Comp failed to save to the policy administration system'
		* Name: 'Workers Comp Save Failed'
		* Id: 477
		*/
        WorkersCompSaveFailed = 477,
		/**
		* Description: 'Workers Comp failed to rate in the policy administration system'
		* Name: 'Workers Comp Rate Failed'
		* Id: 478
		*/
        WorkersCompRateFailed = 478,
		/**
		* Description: 'Delivery Auto failed to save to the policy administration system'
		* Name: 'Delivery Auto Save Failed'
		* Id: 479
		*/
        DeliveryAutoSaveFailed = 479,
		/**
		* Description: 'Delivery Auto failed to rate in the policy administration system'
		* Name: 'Delivery Auto Rate Failed'
		* Id: 480
		*/
        DeliveryAutoRateFailed = 480,
		/**
		* Description: 'Package failed to save to the policy administration system'
		* Name: 'Package Save Failed'
		* Id: 481
		*/
        PackageSaveFailed = 481,
		/**
		* Description: 'Package failed to rate in the policy administration system'
		* Name: 'Package Rate Failed'
		* Id: 482
		*/
        PackageRateFailed = 482,
		/**
		* Description: 'System rules indicate no policies should be created'
		* Name: 'No Policies Should Be Created'
		* Id: 483
		*/
        NoPoliciesShouldBeCreated = 483,
		/**
		* Description: 'Sum of Building Value and Personal Property Value equals or exceeds $1,000,000 for building with frame construction'
		* Name: 'Building with Frame Construction and High Exposure'
		* Id: 485
		*/
        BuildingWithFrameConstructionAndHighExposure = 485,
		/**
		* Description: 'Submission contains CA location(s)'
		* Name: 'California location'
		* Id: 490
		*/
        CaliforniaLocation = 490,
		/**
		* Description: 'System rules indicate location state is referred'
		* Name: 'Location state is referred'
		* Id: 491
		*/
        LocationStateIsReferred = 491
    }

	/**
    * @description description: 'Location Status'
	* name: 'Location Status'
	* id: 129
    */
    export const enum LocationStatus {
        CodeTypeId = 129,
		/**
		* Description: 'Draft '
		* Name: 'Draft'
		* Id: 219
		*/
        Draft = 219,
		/**
		* Description: 'Verified'
		* Name: 'Verified'
		* Id: 220
		*/
        Verified = 220,
		/**
		* Description: 'Complete'
		* Name: 'Complete'
		* Id: 221
		*/
        Complete = 221,
		/**
		* Description: 'Error state when looking up location ISO data'
		* Name: 'Error'
		* Id: 418
		*/
        Error = 418,
		/**
		* Description: 'Incomplete state when looking up location ISO data. Missing required data.'
		* Name: 'Incomplete'
		* Id: 419
		*/
        Incomplete = 419,
		/**
		* Description: 'ISO address validation resulted in zero high confidence matches'
		* Name: 'Invalid Address'
		* Id: 421
		*/
        InvalidAddress = 421
    }

	/**
    * @description description: 'Property Rating Type'
	* name: 'Property Rating Type'
	* id: 130
    */
    export const enum PropertyRatingType {
        CodeTypeId = 130,
		/**
		* Description: 'Non Blanket Class Non Sprinklered Building'
		* Name: 'Non Blanket Class Non Sprinklered Building'
		* Id: 222
		*/
        NonBlanketClassNonSprinkleredBuilding = 222,
		/**
		* Description: 'Non Blanket Sprinklered Schedule'
		* Name: 'Non Blanket Sprinklered Schedule'
		* Id: 223
		*/
        NonBlanketSprinkleredSchedule = 223,
		/**
		* Description: 'Blanket Class Non Sprinklered Building'
		* Name: 'Blanket Class Non Sprinklered Building'
		* Id: 486
		*/
        BlanketClassNonSprinkleredBuilding = 486,
		/**
		* Description: 'Blanket Sprinklered Schedule'
		* Name: 'Blanket Sprinklered Schedule'
		* Id: 487
		*/
        BlanketSprinkleredSchedule = 487,
		/**
		* Description: 'Blanket Schedule'
		* Name: 'Blanket Schedule'
		* Id: 488
		*/
        BlanketSchedule = 488,
		/**
		* Description: 'Non Blanket Schedule'
		* Name: 'Non Blanket Schedule'
		* Id: 489
		*/
        NonBlanketSchedule = 489
    }

	/**
    * @description description: 'Construction Type'
	* name: 'Construction Type'
	* id: 131
    */
    export const enum ConstructionType {
        CodeTypeId = 131,
		/**
		* Description: '1'
		* Name: '1'
		* Id: 224
		*/
        One = 224,
		/**
		* Description: '2'
		* Name: '2'
		* Id: 225
		*/
        Two = 225,
		/**
		* Description: '3'
		* Name: '3'
		* Id: 226
		*/
        Three = 226,
		/**
		* Description: '4'
		* Name: '4'
		* Id: 227
		*/
        Four = 227,
		/**
		* Description: '5'
		* Name: '5'
		* Id: 228
		*/
        Five = 228,
		/**
		* Description: '6'
		* Name: '6'
		* Id: 229
		*/
        Six = 229
    }

	/**
    * @description description: 'Deductible Amount Code for HNO as applied to the Commercial Auto Line of Business on an HNO Policy'
	* name: 'HNO Deductible Amount Code'
	* id: 132
    */
    export const enum HNODeductibleAmountCode {
        CodeTypeId = 132,
		/**
		* Description: '$1,000'
		* Name: '$1,000'
		* Id: 230
		*/
        OneThousand = 230,
		/**
		* Description: '$2,000'
		* Name: '$2,000'
		* Id: 231
		*/
        TwoThousand = 231,
		/**
		* Description: '$5,000'
		* Name: '$5,000'
		* Id: 232
		*/
        FiveThousand = 232,
		/**
		* Description: '$0'
		* Name: '$0'
		* Id: 276
		*/
        Zero = 276,
		/**
		* Description: '$2,500'
		* Name: '$2,500'
		* Id: 277
		*/
        TwoThousandFiveHundred = 277,
		/**
		* Description: '$7,500'
		* Name: '$7,500'
		* Id: 278
		*/
        SevenThousandFiveHundred = 278,
		/**
		* Description: '$10,000'
		* Name: '$10,000'
		* Id: 279
		*/
        TenThousand = 279,
		/**
		* Description: '$15,000'
		* Name: '$15,000'
		* Id: 280
		*/
        FifteenThousand = 280,
		/**
		* Description: '$25,000'
		* Name: '$25,000'
		* Id: 281
		*/
        TwentyFiveThousand = 281
    }

	/**
    * @description description: 'Submission Subjectivity'
	* name: 'Subjectivity'
	* id: 133
    */
    export const enum Subjectivity {
        CodeTypeId = 133,
		/**
		* Description: 'Completed Payment Authorization Form'
		* Name: 'Payment Authorization'
		* Id: 285
		*/
        PaymentAuthorization = 285,
		/**
		* Description: 'Current drivers list submitted to and approved by Intrepid Direct'
		* Name: 'Drivers List'
		* Id: 286
		*/
        DriversList = 286,
		/**
		* Description: 'Confirmation of FEIN for all entities'
		* Name: 'FEIN Confirmation'
		* Id: 287
		*/
        FeinConfirmation = 287,
		/**
		* Description: 'Utilize our self-service online MVR service for your MVR reviews on delivery drivers'
		* Name: 'Self-Service MVR'
		* Id: 288
		*/
        SelfserviceMvr = 288,
		/**
		* Description: 'Signed Application'
		* Name: 'Signed Application'
		* Id: 336
		*/
        SignedApplication = 336
    }

	/**
    * @description description: 'MedPayLimit'
	* name: 'MedPayLimit'
	* id: 134
    */
    export const enum MedPayLimit {
        CodeTypeId = 134,
		/**
		* Description: '0'
		* Name: '0'
		* Id: 289
		*/
        Zero = 289,
		/**
		* Description: '$1,000'
		* Name: '$1,000'
		* Id: 290
		*/
        OneThousand = 290,
		/**
		* Description: '$2,000'
		* Name: '$2,000'
		* Id: 291
		*/
        TwoThousand = 291,
		/**
		* Description: '$3,000'
		* Name: '$3,000'
		* Id: 292
		*/
        ThreeThousand = 292,
		/**
		* Description: '$4,000'
		* Name: '$4,000'
		* Id: 293
		*/
        FourThousand = 293,
		/**
		* Description: '$5,000'
		* Name: '$5,000'
		* Id: 294
		*/
        FiveThousand = 294,
		/**
		* Description: '$10,000'
		* Name: '$10,000'
		* Id: 295
		*/
        TenThousand = 295,
		/**
		* Description: '$15,000'
		* Name: '$15,000'
		* Id: 296
		*/
        FifteenThousand = 296,
		/**
		* Description: '$20,000'
		* Name: '$20,000'
		* Id: 297
		*/
        TwentyThousand = 297,
		/**
		* Description: '$25,000'
		* Name: '$25,000'
		* Id: 298
		*/
        TwentyFiveThousand = 298
    }

	/**
    * @description description: 'The types of reasons that will result in a policy being excluded from a submission request.'
	* name: 'PolicyExclusionReasonType'
	* id: 135
    */
    export const enum PolicyExclusionReasonType {
        CodeTypeId = 135,
		/**
		* Description: 'The submission request is only for locations in monopolistic states'
		* Name: 'Only Monopolistic States'
		* Id: 338
		*/
        OnlyMonopolisticStates = 338,
		/**
		* Description: 'The submission request has no delivery sales specified'
		* Name: 'No Delivery Sales'
		* Id: 339
		*/
        NoDeliverySales = 339,
		/**
		* Description: 'Policy is not available for the brand'
		* Name: 'Not Available For Brand'
		* Id: 340
		*/
        NotAvailableForBrand = 340,
		/**
		* Description: 'Policy is not available within the requested state'
		* Name: 'Not Available In State'
		* Id: 341
		*/
        NotAvailableInState = 341,
		/**
		* Description: 'The submission request has locations in states that are not available'
		* Name: 'Not Available In All States'
		* Id: 400
		*/
        NotAvailableInAllStates = 400
    }

	/**
    * @description description: 'Claims In Last Three Years Question Responses'
	* name: 'Claims In Last Three Years Question Responses'
	* id: 136
    */
    export const enum ClaimsInLastThreeYearsQuestionResponses {
        CodeTypeId = 136,
		/**
		* Description: 'Yes'
		* Name: 'Yes'
		* Id: 343
		*/
        Yes = 343,
		/**
		* Description: 'No'
		* Name: 'No'
		* Id: 344
		*/
        No = 344,
		/**
		* Description: 'Not sure'
		* Name: 'Not sure'
		* Id: 345
		*/
        NotSure = 345
    }

	/**
    * @description description: 'Client Errors'
	* name: 'Client Errors'
	* id: 137
    */
    export const enum ClientErrors {
        CodeTypeId = 137,
		/**
		* Description: 'This account has more than one submission. This scenario is not supported yet.'
		* Name: 'More than one submission for account'
		* Id: 402
		*/
        MoreThanOneSubmissionForAccount = 402,
		/**
		* Description: 'A submission could not be found with the lookup parameters provided from TechCanary.'
		* Name: 'Submission lookup failed, not found'
		* Id: 403
		*/
        SubmissionLookupFailedNotFound = 403
    }

	/**
    * @description description: 'Commercial Auto Package Deductible Amount Code'
	* name: 'Commercial Auto Package Deductible Amount Code'
	* id: 141
    */
    export const enum CommercialAutoPackageDeductibleAmountCode {
        CodeTypeId = 141,
		/**
		* Description: '500'
		* Name: '500'
		* Id: 471
		*/
        FiveHundred = 471
    }

	/**
    * @description description: 'Commercial Auto Package Limit Amount Code'
	* name: 'Commercial Auto Package Limit Amount Code'
	* id: 142
    */
    export const enum CommercialAutoPackageLimitAmountCode {
        CodeTypeId = 142,
		/**
		* Description: '1000000'
		* Name: '1000000'
		* Id: 472
		*/
        OneMillion = 472
    }

	/**
    * @description description: 'Auto Symbol Code'
	* name: 'Auto Symbol Code'
	* id: 143
    */
    export const enum AutoSymbolCode {
        CodeTypeId = 143,
		/**
		* Description: 'Owned Autos Subject To UM'
		* Name: 'Owned Autos Subject To UM'
		* Id: 473
		*/
        OwnedAutosSubjectToUm = 473,
		/**
		* Description: 'Spec Described Autos'
		* Name: 'Spec Described Autos'
		* Id: 474
		*/
        SpecDescribedAutos = 474,
		/**
		* Description: 'Hired Autos Only'
		* Name: 'Hired Autos Only'
		* Id: 475
		*/
        HiredAutosOnly = 475,
		/**
		* Description: 'Non Owned Autos Only'
		* Name: 'Non Owned Autos Only'
		* Id: 476
		*/
        NonOwnedAutosOnly = 476
    }


	/**
    * @description description: List of strongly typed IDs from the brands table
    */
    export class BusinessProgram {
		/**
		* Description: 'Marcos'
		* Name: 'Marcos'
		* Alias: 169
		*/
        Marcos:string = '169';
		/**
		* Description: 'Pizza-All Other'
		* Name: 'Pizza-All Other'
		* Alias: 170
		*/
        PizzaallOther:string = '170';
		/**
		* Description: 'Papa John's'
		* Name: 'Papa Johns'
		* Alias: 211
		*/
        PapaJohns:string = '211';
		/**
		* Description: 'Jet's Pizza'
		* Name: 'Jets Pizza'
		* Alias: 212
		*/
        JetsPizza:string = '212';
		/**
		* Description: 'Domino's'
		* Name: 'Dominos'
		* Alias: 213
		*/
        Dominos:string = '213';
		/**
		* Description: 'Mellow Mushroom'
		* Name: 'Mellow Mushroom'
		* Alias: 214
		*/
        MellowMushroom:string = '214';
		/**
		* Description: 'Hungry Howie's'
		* Name: 'Hungry Howies'
		* Alias: 215
		*/
        HungryHowies:string = '215';
		/**
		* Description: 'Pizza Hut'
		* Name: 'Pizza Hut'
		* Alias: 216
		*/
        PizzaHut:string = '216';
		/**
		* Description: 'Jimmy John's'
		* Name: 'Jimmy Johns'
		* Alias: 217
		*/
        JimmyJohns:string = '217';
		/**
		* Description: 'Other'
		* Name: 'Restaurant-All Other'
		* Alias: 218
		*/
        RestaurantallOther:string = '218';
		/**
		* Description: 'Dairy Queen'
		* Name: 'Dairy Queen'
		* Alias: 346
		*/
        DairyQueen:string = '346';
		/**
		* Description: 'Dunkin' Donuts'
		* Name: 'Dunkin' Donuts'
		* Alias: 347
		*/
        DunkinDonuts:string = '347';
		/**
		* Description: 'Firehouse Subs'
		* Name: 'Firehouse Subs'
		* Alias: 348
		*/
        FirehouseSubs:string = '348';
		/**
		* Description: 'Toppers'
		* Name: 'Toppers'
		* Alias: 349
		*/
        Toppers:string = '349';
		/**
		* Description: 'Qdoba'
		* Name: 'Qdoba'
		* Alias: 350
		*/
        Qdoba:string = '350';
		/**
		* Description: 'Zaxby's'
		* Name: 'Zaxby's'
		* Alias: 351
		*/
        Zaxbys:string = '351';
		/**
		* Description: 'KFC'
		* Name: 'KFC'
		* Alias: 404
		*/
        Kfc:string = '404';
		/**
		* Description: 'Burger King'
		* Name: 'Burger King'
		* Alias: 407
		*/
        BurgerKing:string = '407';
		/**
		* Description: 'Carl's Jr.'
		* Name: 'Carl's Jr.'
		* Alias: 408
		*/
        CarlsJr:string = '408';
		/**
		* Description: 'Five Guys'
		* Name: 'Five Guys Burgers and Fries'
		* Alias: 409
		*/
        FiveGuysBurgersAndFries:string = '409';
		/**
		* Description: 'Freddy's'
		* Name: 'Freddy's'
		* Alias: 410
		*/
        Freddys:string = '410';
		/**
		* Description: 'Hardee's'
		* Name: 'Hardee's'
		* Alias: 411
		*/
        Hardees:string = '411';
		/**
		* Description: 'Jack in the Box'
		* Name: 'Jack in the Box'
		* Alias: 412
		*/
        JackInTheBox:string = '412';
		/**
		* Description: 'Jersey Mike's'
		* Name: 'Jersey Mike's'
		* Alias: 413
		*/
        JerseyMikes:string = '413';
		/**
		* Description: 'Little Caesars'
		* Name: 'Little Caesars'
		* Alias: 414
		*/
        LittleCaesars:string = '414';
		/**
		* Description: 'McDonald's'
		* Name: 'McDonald's'
		* Alias: 415
		*/
        Mcdonalds:string = '415';
		/**
		* Description: 'Sonic'
		* Name: 'Sonic'
		* Alias: 416
		*/
        Sonic:string = '416';
		/**
		* Description: 'Taco Bell'
		* Name: 'Taco Bell'
		* Alias: 417
		*/
        TacoBell:string = '417';
		/**
		* Description: 'Garage - Collision Repair - Other'
		* Name: 'Garage - Collision Repair - Other'
		* Alias: AA_COLLRPR
		*/
        GarageCollisionRepairOther:string = 'AA_COLLRPR';
		/**
		* Description: 'Garage - General Repair - Other'
		* Name: 'Garage - General Repair - Other'
		* Alias: AA_OTHAUTO
		*/
        GarageGeneralRepairOther:string = 'AA_OTHAUTO';
		/**
		* Description: 'Garage - Lube Shop - Other'
		* Name: 'Garage - Lube Shop - Other'
		* Alias: AA_LBSHP
		*/
        GarageLubeShopOther:string = 'AA_LBSHP';
		/**
		* Description: 'Fitness - Other'
		* Name: 'Fitness - Other'
		* Alias: FITNESS
		*/
        FitnessOther:string = 'FITNESS';
		/**
		* Description: 'Smoothie King'
		* Name: 'Smoothie King'
		* Alias: REST_OTH
		*/
        SmoothieKing:string = 'REST_OTH';
		/**
		* Description: 'Tropical Smoothie Cafe'
		* Name: 'Tropical Smoothie Cafe'
		* Alias: REST_OTH
		*/
        TropicalSmoothieCafe:string = 'REST_OTH';
		/**
		* Description: 'Chick-fil-A'
		* Name: 'Chick-fil-A'
		* Alias: CFA
		*/
        Chickfila:string = 'CFA';
    }


    /**
    * @description description: List of strongly typed IDs from the verticals table
	* name: Verticals
    */
    export class Verticals {        
		/**
		* Description: 'Fitness'
		* Name: 'Fitness'
		* Id: 7
		*/
         static Fitness = 'Fitness';
		/**
		* Description: 'Garage'
		* Name: 'Garage'
		* Id: 2
		*/
         static Garage = 'Garage';
		/**
		* Description: 'Restaurant'
		* Name: 'Restaurant'
		* Id: 1
		*/
         static Restaurant = 'Restaurant';
    }
}
